import classnames from "classnames";
import React from "react";

import { AdditionalServiceComponent } from "@components/Product/AdditionalService/additionalService.component";
import { formatPriceForEcommerce } from "@components/Product/ECommerce/delivery/deliveryBlock/deliveryItem/deliveryItem.component";
import { TooltipType } from "@components/Product/ECommerce/eCommerce.types";

import {
    AdditionalServiceModel,
    ProductDocument,
} from "lib/@types/service/shared";

type AdditionalServiceProps = {
    serviceProduct: AdditionalServiceModel;
    onServiceProductClick: (serviceProduct: AdditionalServiceModel) => void;
    activeServiceProducts: string[];
    tooltip?: TooltipType;
    documents?: Array<ProductDocument>;
};

const AdditionalService = ({
    serviceProduct,
    onServiceProductClick,
    activeServiceProducts,
    tooltip,
    documents,
}: AdditionalServiceProps) => {
    const isActiveProduct = activeServiceProducts.includes(serviceProduct.sku);

    return (
        <div className={"d-flex delivery-item__serviceProduct mt-2"}>
            <AdditionalServiceComponent
                additionalService={serviceProduct}
                tooltip={tooltip}
                type={"checkbox"}
                isSelected={isActiveProduct}
                onClick={onServiceProductClick}
                documents={documents}
            />
            <p
                className={classnames(
                    "font-weight-bold m-0 text-right delivery-item__cost",
                )}
            >
                {serviceProduct.price &&
                    formatPriceForEcommerce(serviceProduct.price)}
            </p>
        </div>
    );
};

export { AdditionalService };
